module.exports = __webpack_public_path__ + "static/img/btn1.5afd49ad.png";